<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    data-token-name="IconBell_24"
>
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.607 3.82A6.209 6.209 0 0 1 18.21 8.216c0 2.93.627 4.743 1.199 5.793.288.528.567.873.76 1.076a2.56 2.56 0 0 0 .258.24h.001a.952.952 0 0 1-.54 1.737H4.111a.952.952 0 0 1-.541-1.736l.001-.001a2.555 2.555 0 0 0 .259-.24c.192-.203.471-.548.759-1.076.573-1.05 1.199-2.863 1.199-5.793 0-1.648.654-3.229 1.818-4.394Zm3.097 14.956a.952.952 0 1 0-1.758.734c.293.701.729 1.321 1.291 1.771.567.454 1.247.72 1.97.72.721 0 1.4-.266 1.968-.72.563-.45.998-1.07 1.29-1.771a.952.952 0 1 0-1.757-.734c-.19.457-.45.8-.723 1.018-.269.215-.537.301-.779.301s-.51-.086-.779-.301c-.273-.219-.532-.56-.723-1.018Z"
        fill="currentColor"
    />
</svg>
